/* eslint-disable react/prop-types */
import React from 'react';
import WealthListGuesser from '../../base/components/guesser/wealth-list.guesser';

function GroupList(props) {
  return (
    <>
      <WealthListGuesser
        {...props}
        excludeFields={['desc', 'currencies', 'brands']}
        excludeFilterInputs={['brands']}
        fieldOrder={['id', 'created', 'updated', 'name', 'code', 'managerEmail', 'enabled']}
      />
    </>
  );
}

export default GroupList;
